import React from 'react'

export const Loading: React.FC = ({}) => (
  <div className="loading">
    <span className="fa fa-spinner-third fa-spin" />
  </div>
)
